import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";

import { Login } from "./pages/login/components/login/login.component";
import { ForgotPassword } from "./pages/forgot-password/components/forgot-password/forgot-password.component";
import { history } from "./types/history";
import { AppRoutes } from "./app.routes";
import { ProtectedRoute } from "./features/auth/components/protected-route/protected-route.component";

const App = () => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact={true} path="/login" render={() => <Login />} />
        <Route exact={true} path="/forgot-password" render={() => <ForgotPassword />} />
        {AppRoutes.map((route) => (
          <ProtectedRoute exact={false} key={route.path} path={route.path} route={route} />
        ))}
        <Redirect from="/" to="/campaign-briefs" />
      </Switch>
    </ConnectedRouter>
  );
};

export default App;
